/**
 * Parse a telemetry timestamp to epoch ms.
 *
 * Timestream often returns UTC as "YYYY-MM-DD HH:mm:ss.sss" with no timezone.
 * `Date.parse` treats that as *local* time, which shifts charts (e.g. Mountain
 * UTC−6 shows midnight UTC at 6:00am). Treat timezone-less values as UTC.
 */
export function parseTelemetryTimeMs(time: string): number | null {
  if (!time) return null;
  const raw = time.trim();
  if (!raw) return null;

  let normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
  // Cap fractional seconds (Timestream may send nanos)
  normalized = normalized.replace(/\.(\d{3})\d*/, '.$1');

  if (!/[zZ]$|[+-]\d{2}:?\d{2}$/.test(normalized)) {
    normalized = `${normalized}Z`;
  }

  const ms = Date.parse(normalized);
  return Number.isFinite(ms) ? ms : null;
}

/** Same rules as {@link parseTelemetryTimeMs}, for `new Date(...)` display paths. */
export function parseTelemetryDate(time: string): Date | null {
  const ms = parseTelemetryTimeMs(time);
  return ms == null ? null : new Date(ms);
}
